import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '~/state';
import { selectIsAuthenticated } from '~/state/auth';

export function ProtectedRoute() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}
